(() => {
  // app/scripts/mega-tab-component.js
  var customElementsName = "mega-tab";
  !window.customElements.get(customElementsName) && window.customElements.define(customElementsName, class extends HTMLElement {
    constructor() {
      super();
      const { editor } = theme;
      this.querySelectorAll(".jsMegaTabTitle")?.forEach((item) => {
        item.addEventListener("tabChange", this.changeTab.bind(this));
        !editor && item.addEventListener("mouseenter", this.changeTab.bind(this));
        !editor && item.addEventListener("focusin", this.changeTab.bind(this));
      });
      !editor && this.closest("li")?.addEventListener("mouseleave", (e) => {
        this.removeActiveTab();
        this.querySelector(".jsMegaTabTitle")?.dispatchEvent(new CustomEvent("tabChange"));
      });
    }
    changeTab(e) {
      const element = e.target.closest(".jsMegaTabTitle");
      this.removeActiveTab(element);
      element.classList.add("active", "highlight");
    }
    removeActiveTab(el) {
      this.querySelectorAll("[data-tab-id].active")?.forEach((i) => {
        i != el && i.classList.remove("active", "highlight");
      });
    }
  });
})();
